import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { InsuranceTermsLink } from '../../../insurance/terms-link';
import { InsuranceKBLink } from '../../../insurance/kb-link';
import { EventSourceStrings } from '../../../tracking/tracking-constants';

import { parcelGuardTooltipMessages } from './messages';
import style from './style.module.css';

const InsuranceBody = ({ selectedInsuranceOptionId }) => (
  <div>
    <div className={style['popover-body']}>
      <FormattedMessage
        {...parcelGuardTooltipMessages.body}
        values={{
          helpArticleLink: (chunks) => <InsuranceKBLink insuranceProviderId={selectedInsuranceOptionId}>{chunks}</InsuranceKBLink>,
          termsLink: (chunks) => (
            <>
              <InsuranceTermsLink insuranceProviderId={selectedInsuranceOptionId} source={EventSourceStrings.CSW_INSURANCE_FIELD}>
                {chunks}
              </InsuranceTermsLink>
              <FontAwesomeIcon className={style.icon} icon={faExternalLinkAlt} />
            </>
          ),
        }}
      />
    </div>
    <div className={style['popover-disclaimer']}>
      <FormattedMessage {...parcelGuardTooltipMessages.disclaimer} />
    </div>
  </div>
);

InsuranceBody.propTypes = {
  selectedInsuranceOptionId: PropTypes.string.isRequired,
};

export default InsuranceBody;
